import { render, staticRenderFns } from "./ChatBotModal.vue?vue&type=template&id=069b23f5&lang=pug&"
import script from "./ChatBotModal.vue?vue&type=script&lang=js&"
export * from "./ChatBotModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports